<template>
  <div class="caseBox">
    <div class="caseBoxTop">
      <p>{{ caseTitle.Name }}</p>
    </div>
    <div class="caseBoxBottom">
      <div
        class="caseBoxBottomItem"
        v-for="item in customerCaseList"
        :key="item.ID"
        @click="goCaseShow(item)"
      >
        <div class="itemImg">
          <img
            src="../../img/caseboxItem.png"
            v-lazy="item.TitlePic"
            :key="item.TitlePic"
            alt=""
          />
        </div>
        <p class="itemTitle">{{ item.Title }}</p>
        <p class="itemInfo">{{ item.Info }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { customerCase } from "@/api/client";
import request from "@/utils/request";
export default {
  props: {
    caseTitle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      customerCaseList: [] // 用户中心列表
    };
  },
  mounted() {
    this.customerCase({ ID: this.caseTitle.ID });
  },

  methods: {
    // 客户案例中心
    async customerCase(data) {
      const res = await customerCase(data);
      // console.log(res, 'customerCasecustomerCase')
      if (res.Msg === "获取成功") {
        this.customerCaseList = res.Data;
        this.customerCaseList.forEach(item => {
          item.TitlePic = request.defaults.baseURL + item.TitlePic;
          // console.log(item.TitlePic, 'item.TitlePicitem.TitlePicitem.TitlePic')
        });
      }
    },
    goCaseShow(item) {
      this.$router.push({ path: `/caseShow/${item.ID}` });
    }
  }
};
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun: 100/192;
.caseBox {
  width: 1400px * $sun;
  margin: auto;
}
// 大标题
.caseBoxTop {
  width: 100%;
  height: 45px * $sun;
  border-bottom: 4px * $sun solid #eee;
  margin-bottom: 10px;
  p {
    margin: 0;
    width: 180px * $sun;
    height: 45px * $sun;
    border-bottom: 4px * $sun solid #2380e1;
    font-size: 22px * $sun;
    font-weight: 700;
    color: #2380e1;
    text-align: center;
  }
}
// 案例列表
.caseBoxBottom {
  width: 1400px * $sun;
  margin: auto;
  overflow: hidden;
  margin-bottom: 80px * $sun;
  p {
    margin: 0;
  }
  .caseBoxBottomItem {
    float: left;
    width: 282px * $sun;
    height: 320px * $sun;
    margin-right: 90px * $sun;
    .itemImg {
      width: 266px * $sun;
      height: 137px * $sun;
      margin: auto;
      margin-bottom: 44px * $sun;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .itemTitle {
      width: 100%;
      height: 24px * $sun;
      margin-bottom: 29px * $sun;
      font-size: 18px * $sun;
      font-weight: bold;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      white-space: nowrap; //溢出不换行
    }
    .itemInfo {
      width: 100%;
      height: 85px * $sun;
      font-size: 16px * $sun;
      font-weight: 500;
      line-height: 28px * $sun;
      color: #666666;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }
  .caseBoxBottomItem:nth-of-type(4n) {
    margin-right: 0;
  }
}
</style>
